import type { ReactNode } from 'react';

export const symbol_forward_to_inbox: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M820-740H140v520h360q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H140q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h680q24 0 42 18t18 42v280q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-280Zm-680 0v520-210 4-314Zm340 218 340-218v55L496-473q-7.5 5-15.75 5T464-473L140-678v-62l340 218Zm325 362H620q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h185l-53-53q-9-9-8.5-21t9.5-21.39q9-8.61 21-8.61t21 9l104 104q5 5 7 10.09t2 10.91q0 5-2 10.5t-7 10.5L795-65q-9 9-21 9t-21-9q-9-9-8.5-21t8.5-21l52-53Z"
		/>
	</svg>
);
